import { ChevronRight } from "lucide-react";
import { Collapse } from "~/components/ui";
import cn from "classnames";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSetShowPredefinedTasks, useShowPredefinedTasks } from "~/store/ui-preferences.store";
import { PredefinedTasksGrid } from "./predefined-tasks-grid";

const PREDEFINED_TASKS_KEY = "predefined-tasks";

interface PredefinedTasksProps {
  className?: string;
}

export const PredefinedTasks: FunctionComponent<PredefinedTasksProps> = ({ className }) => {
  const { t } = useTranslation();
  const showPredefinedTasks = useShowPredefinedTasks();
  const setShowPredefinedTasks = useSetShowPredefinedTasks();

  const handleCollapseChange = (activeKeys: string[]) => {
    setShowPredefinedTasks(activeKeys.includes(PREDEFINED_TASKS_KEY));
  };

  return (
    <div className={cn(className, "bg-noa")}>
      <Collapse
        size="small"
        bordered={false}
        className="bg-noa"
        expandIcon={({ isActive }) => (
          <ChevronRight className={cn("transition-transform", { "rotate-90": isActive })} />
        )}
        defaultActiveKey={showPredefinedTasks ? [PREDEFINED_TASKS_KEY] : []}
        onChange={handleCollapseChange}
        items={[
          {
            key: PREDEFINED_TASKS_KEY,
            label: t("predefinedTasks:title"),
            children: <PredefinedTasksGrid />,
          },
        ]}
      />
    </div>
  );
};
